import { getUrlParams, pushUrlParams } from "../../services/service-url-params";
import { generateTagDate } from "../../services/service-date";
import flatpickr from "flatpickr";
import {Danish} from "flatpickr/dist/l10n/da.js";
import { typeAhead } from "../../services/service-typeAhead";
import { generatePager } from "../../services/service-pager";
export default class EventFilter {
  constructor(element) {
    this.el = element
    this.query = "https://laka.ankiro.dk/Rest/Events/Search.json?";
    this.typeAheadQuery = "https://laka.ankiro.dk/Rest/Events/TypeAhead.json"
    this.pagePerView = 12;
    this.typeAheadArray = [];
    this.params = getUrlParams();
    

    this.pager = this.el.querySelector("[data-pager]");
    this.pagers = this.el.querySelectorAll("[data-page]");
    this.nextPage = this.el.querySelector("[data-next]");
    this.prevPage = this.el.querySelector("[data-prev]");
    this.buttons = this.el.querySelectorAll("button");
    this.searchInput = this.el.querySelector("#event-search");
    this.locationSelect = this.el.querySelector("#location");
    this.periodePicker = this.el.querySelector("#periodepicker");
    this.onlinePicker = this.el.querySelector("#online");
    this.OpenPicker = this.el.querySelector("#open")
    this.eventList = this.el.querySelector("[data-eventlist]")
    this.showingPages = this.el.querySelector("[data-showingpages]");
    this.dateRangeInput = this.el.querySelector(".flatpickr");
    this.TypeAheadContainer = this.el.querySelector("[data-typeahead]");
    
    this.isAuth = this.el.dataset.isauth;
    this.membersOnlyText = this.el.dataset.membersonly;
    this.readMoreText = this.el.dataset.readmore;

    this.initFlatpicker = this.initFlatpicker.bind(this);
    this.toggelPager = this.toggelPager.bind(this);
    this.setPage = this.setPage.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrev = this.gotoPrev.bind(this);
    this.enterSearchParam = this.enterSearchParam.bind(this);
    this.enterLocationParam = this.enterLocationParam.bind(this);
    this.enterOnlineParam = this.enterOnlineParam.bind(this);
    this.enterOpenParam = this.enterOpenParam.bind(this);
    this.setPageParams = this.setPageParams.bind(this);
    this.generateSearcgQuery = this.generateSearcgQuery.bind(this);
    this.generateSearchResult = this.generateSearchResult.bind(this);
    this.listenToPager = this.listenToPager.bind(this);
    this.generateShowing = this.generateShowing.bind(this);


    this.init()
  }

  init(){

    this.setPageParams();

    if (this.searchInput){
      this.searchInput.addEventListener('keydown', e =>{
        if (e.keyCode === 13){
          this.enterSearchParam();
        }
      })
      this.searchInput.addEventListener('keyup', e =>{
        if (e.keyCode != 13 && this.searchInput.value.length >=3 ){
          typeAhead(this.searchInput.value, this.typeAheadQuery, this.TypeAheadContainer, this.searchInput)          
        }else{
          this.TypeAheadContainer.classList.add("h-0");
          this.TypeAheadContainer.classList.remove("h-auto");
        }
      })
    }

    if (this.locationSelect){
      this.locationSelect.addEventListener('change', e =>{
        this.enterLocationParam();
      })
    }

    if (this.onlinePicker){
      this.onlinePicker.addEventListener('change', e =>{
        this.enterOnlineParam();
      })
    }

    if (this.OpenPicker){
      this.OpenPicker.addEventListener('change', e =>{
        this.enterOpenParam();
      })
    }

    if (this.buttons){
      this.buttons.forEach(button => {
        button.addEventListener('click', e =>{
          let type = button.dataset.type;
          switch (type){
            case "search":
              this.enterSearchParam();
              break;
            case "prev":
              this.gotoPrev();
              break;
            case "next":
              this.gotoNext();
              break;
            case "page":
              this.setPage(button);
              break;
            default:
              
              break;
          }
        })
      })
    }

    if (this.dateRangeInput){
      this.initFlatpicker(this.dateRangeInput);      
    }
  }

  enterOpenParam(){
    let params = getUrlParams();
    if (this.OpenPicker.checked){
      params.membersOnly="False"
    }
    else{
      delete params.membersOnly;
    }
    delete params.startIndex;
    pushUrlParams(params);
    this.generateSearcgQuery();
  }

  enterOnlineParam(){
    let params = getUrlParams();
    if (this.onlinePicker.checked){
      params.isOnline="true"
    }
    else{
      delete params.isOnline;
    }
    delete params.startIndex;
    pushUrlParams(params);
    this.generateSearcgQuery();
  }

  enterLocationParam(){
    let params = getUrlParams();    
    let location = this.locationSelect.value;
    
    if (location.trim().length > 0){
      params['location'] = location;
    }else{
      delete params.location
    }
    delete params.startIndex;
    pushUrlParams(params)    
    this.generateSearcgQuery();
  }  

  enterSearchParam(){
    let params = getUrlParams()
    let query = this.searchInput.value;
    
    if (query.trim().length > 0){      
      params['query'] = query
    }
    else{
      params['query'] = '*'
    }
    delete params.startIndex;
    pushUrlParams(params);
    this.generateSearcgQuery();
  }


  toggelPager(to, from){
    from.classList.remove("active-pager");
    from.classList.add("pager");
    to.classList.remove("pager");
    to.classList.add("active-pager");
  }

  setPage(page){
    let params = getUrlParams();
    let pagenr = parseInt(page.dataset.page) - 1
    let onePlus = pagenr > 0 ? 1 : 0
    let offset = (pagenr * this.pagePerView) + onePlus
    params['startIndex'] = offset
    pushUrlParams(params);
    this.generateSearcgQuery();
    let activePage = this.el.querySelector(".active-pager")
    this.toggelPager(page, activePage);

  }

  gotoNext(){
    let activePage = this.el.querySelector(".active-pager");
    let nextPageNumber = parseInt(activePage.dataset.page) + 1;
    let nextPage = this.el.querySelector("[data-page='"+ nextPageNumber +"']");
    if (nextPage){
      this.toggelPager(nextPage, activePage); 
    }    
  }

  gotoPrev(){
    
    if (prevPage){
      this.toggelPager(prevPage, activePage); 
    }
  }

  initFlatpicker(field){
    let params = getUrlParams();
    let defaultDates = [];
    if (params.DateFrom != null && params.DateTo != null){
      let newFromDate = new Date(params.DateFrom);
      let newToDate = new Date(params.DateTo);
      
      let defaultFromDate = newFromDate.getDate().toString().padStart(2,'0') + "-" + (newFromDate.getMonth() + 1).toString().padStart(2,'0') + "-" + newFromDate.getFullYear()
      let defaultToDate = newToDate.getDate().toString().padStart(2,'0') + "-" + (newToDate.getMonth() + 1).toString().padStart(2,'0') + "-" + newToDate.getFullYear()
      defaultDates = [defaultFromDate, defaultToDate]
      
      
    }
    let fromDate;
    let toDate
    let config = {
      mode: "range",
      minDate: "today",
      dateFormat: "d-m-Y",
      defaultDate:defaultDates,
      conjunction: "til",
      locale:Danish,
      onChange: function(selectedDates, dateStr, instance){
        let params = getUrlParams();
        
        if (selectedDates[0] != null){
          fromDate = selectedDates[0].getFullYear() + "-" + (selectedDates[0].getMonth() + 1) + "-" + ("0" + selectedDates[0].getDate()).slice(-2);
        }else{
          fromDate = null
        }
        if (selectedDates[1] != null){
          toDate = selectedDates[1].getFullYear() + "-" + (selectedDates[1].getMonth() + 1) + "-" + ("0" + selectedDates[1].getDate()).slice(-2); 
        } else{
          toDate = null
        }
        
        if(fromDate != null && toDate != null){
          params.DateFrom = fromDate;
          params.DateTo = toDate;
          delete params.startIndex;
          pushUrlParams(params);
          this.generateSearcgQuery()
        }
        
        if (fromDate == null && toDate == null){          
          delete params.DateFrom;
          delete params.DateTo;
          delete params.startIndex;
          pushUrlParams(params);
          this.generateSearcgQuery()
        }
        
      }.bind(this)    
    }
    
    flatpickr(field, config)    
  }

  setPageParams(){
    let params = getUrlParams();
    
    if (params.query && params.query != '*'){
      this.searchInput.value = params.query;      
    }
    if (params.location != null){
      this.locationSelect.value = params.location      
    }
    if (params.isOnline != null){
      this.onlinePicker.checked = true;
    }
    if (params.membersOnly != null){
      this.OpenPicker.checked = true;
    }
    this.generateSearcgQuery();
    
    
  }
    
    generateSearcgQuery(){
      let params = getUrlParams();
      let fullQuery = this.query;
      
      if (params.query != undefined){
        fullQuery = fullQuery + "&q=" + params.query
      }else{
        params['query'] = '*'
        pushUrlParams(params);
        fullQuery = fullQuery + "&q=*"
      }
      if (params.location != null){
        fullQuery = fullQuery + "&Location=" + params.location
      }
      if (params.isOnline != null){
        fullQuery = fullQuery + "&isOnline=" + params.isOnline
      }
      if (params.membersOnly != null){
        fullQuery = fullQuery + "&membersOnly=" + params.membersOnly
      }
      if (params.DateFrom != null){
        fullQuery = fullQuery + "&DateFrom=" + params.DateFrom
      }
      if (params.DateTo != null){
        fullQuery = fullQuery + "&DateTo=" + params.DateTo
      }
      if (params.startIndex != null){
        fullQuery = fullQuery +"&startIndex=" + params.startIndex;
      }

      fullQuery = fullQuery + "&MaxResults=12&Sort-By=startDate"
      
      console.log('fullQuery: ', fullQuery)
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ASP.NET_SessionId=5lkk0jncard4so5vpivieiir");

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(fullQuery, requestOptions)
        .then(response => response.json())
        .then(result => {
          this.generateSearchResult(result)
          generatePager(result, this.pagePerView, this.pager);
          this.listenToPager()
        })
        .catch(error => console.log('error', error));
    }
    
    generateSearchResult(json){
      this.generateShowing(json.TotalResults, json.Offset);
      const eventResult = json.Documents.map(document =>{
      return `
      <a itemscope itemtype="https://schema.org/Event" href="${document.Properties.find(x => x.Name === 'url').Value}?date=${document.Properties.find(x => x.Name === 'id').Value}" class="col-span-12 sm:col-span-6  lg:col-span-3 border-[1px] border-blue relative flex flex-col justify-between group min-h-[350px] pt-8 px-6 pb-6 hover:bg-blue-10 hover:shadow-hover group">
			  <div class="mb-5">
        <div class="flex items-center mb-2 gap-1"><svg class="w-3 h-4"><use xlink:href="/spritemap.svg#sprite-location"></use></svg><span class="text-xs" itemprop="location">${document.Properties.find(x => x.Name === 'location').Value}</span></div>
				<p class="text-lg font-bold mb-4" itemprop="name">${document.Properties.find(x => x.Name === 'title').Value}</p>
				<p class="" itemprop="description">${document.Properties.find(x => x.Name === 'intro').Value}</p>				
			</div>
			<div>
        <div class="mt-4 flex items-center flex-wrap gap-3">
          ${document.Properties.find(x => x.Name === 'membersOnly').Value == "True"?`
          <span class="bg-blue-20 text-blue inline-flex items-center justify-center gap-1 rounded-full px-3 py-1 text-xs"><svg class="w-4 h-4"><use xlink:href="/${this.isAuth != "True"?`spritemap.svg#sprite-bluelock`:`spritemap.svg#sprite-openlock`}"></use></svg><span>${this.membersOnlyText}</span></span>
          `:``}
          
				</div>
				<span class="mt-6 flex items-center gap-4 group text-blue mb-4 font-bold"><span>${this.readMoreText}</span><svg class="h-6 w-6 fill-blue dot-arrow-animation"><use xlink:href="/spritemap.svg#sprite-dotarrow"></use></svg></span>
			</div>
			<div class="absolute -top-11 -right-1 bg-orange-40 rounded-full p-2 w-20 h-20 font-semibold flex justify-center items-center text-center leading-5">
				<span itemprop="startDate">${generateTagDate(document.Properties.find(x => x.Name === 'startDate').Value)}</span>
			</div>
		</a>
      `
    }).join("");
 
    if (json.TotalResults > 0 ){
      this.eventList.innerHTML = eventResult;
    }else{
      this.eventList.innerHTML = `<span class="text-blue col-span-12">${this.el.dataset.noresult}</span>`;
    }

  }

  listenToPager(){
    let pageerButtons = this.el.querySelectorAll("[data-type='page']");
    pageerButtons.forEach(button =>{
      button.addEventListener('click', e =>{
        window.scrollTo({top: 0, behavior: 'smooth'});
        this.setPage(button);
      })
    })
  }

  generateShowing(total, offset){
    let startpage = offset < 1 ? `1` : `${offset + 1}`;
    let endpage = offset < 1 ? total < this.pagePerView ? total : this.pagePerView : total < offset + this.pagePerView ? total : offset + this.pagePerView;
    this.showingPages.innerHTML = `${this.el.dataset.showing}  ${total > 0 ? `${startpage}-${endpage}`:`${total}`} ${this.el.dataset.resultof} ${total}`
  }

}